export enum InspectionActionEventType {
    DELETED,
    UPDATED
}

export interface InspectionActionEvent {
    type: InspectionActionEventType;
    payload?: unknown;
}
